import { MESSAGE_TYPE } from '@/src/features/message/models/Message.enums'
import type { TMessageKey } from '@/src/lang/useTranslate'

export const messageAutoTypes = [
  MESSAGE_TYPE.PRAYER,
  MESSAGE_TYPE.PRAYER_ON_COMMENT,
  MESSAGE_TYPE.THANKS_INTENTION_PRAYER,
  MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER,
  MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER,
  MESSAGE_TYPE.GODSON_JOINED,
] as const

export type TChatMessageAutoType = (typeof messageAutoTypes)[number]

type TChatMessageTranslationsKeys = {
  fromMe: TMessageKey
  toMe: TMessageKey
}
type TChatMessageAutoData = {
  title: TChatMessageTranslationsKeys
  comment?: TChatMessageTranslationsKeys
  emoji: string
}

export const chatMessageAutoData: Record<TChatMessageAutoType, TChatMessageAutoData> = {
  [MESSAGE_TYPE.GODSON_JOINED]: {
    title: {
      fromMe: 'message.godfather.welcome-title.to-godfather',
      toMe: 'message.godfather.welcome-title.to-godson',
    },
    comment: {
      fromMe: 'message.godfather.welcome-message.to-godfather',
      toMe: 'message.godfather.welcome-message.to-godson',
    },
    emoji: '👋',
  },
  [MESSAGE_TYPE.PRAYER]: {
    title: {
      fromMe: 'message.prayer.you-prayed-for.long',
      toMe: 'message.prayer.has-prayed-for-you.long',
    },
    emoji: '🔥',
  },
  [MESSAGE_TYPE.THANKS_INTENTION_PRAYER]: {
    title: {
      fromMe: 'word.thank-you',
      toMe: 'word.thank-you',
    },
    comment: {
      fromMe: 'message.prayer-on-intention.thank-you',
      toMe: 'message.prayer-on-intention.thanked-you',
    },
    emoji: '🙏',
  },
  [MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER]: {
    title: {
      fromMe: 'word.thank-you',
      toMe: 'word.thank-you',
    },
    comment: {
      fromMe: 'message.prayer-on-birthday.you-thanked-for',
      toMe: 'message.prayer-on-birthday.has-thanked-you',
    },
    emoji: '🎂',
  },
  [MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER]: {
    title: {
      fromMe: 'word.thank-you',
      toMe: 'word.thank-you',
    },
    comment: {
      fromMe: 'message.prayer-on-arrival.you-thanked-for',
      toMe: 'message.prayer-on-arrival.has-thanked-you',
    },
    emoji: '👋',
  },
  [MESSAGE_TYPE.PRAYER_ON_COMMENT]: {
    title: {
      fromMe: 'words.you-prayed',
      toMe: 'words.has-prayed',
    },
    emoji: '🙏',
  },
}
